var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.49691e-07 8C-1.56865e-07 12.4113 3.58866 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58866 12.4113 -5.42517e-07 8 -3.49691e-07C3.58866 -1.56865e-07 -5.42517e-07 3.58866 -3.49691e-07 8ZM8.47134 5.52866L11.8047 8.862C11.9347 8.992 12 9.16266 12 9.33334C12 9.504 11.9347 9.67469 11.8047 9.80469C11.544 10.0653 11.1227 10.0653 10.862 9.80469L8 6.94266L5.138 9.80466C4.87734 10.0653 4.456 10.0653 4.19534 9.80466C3.93469 9.544 3.93469 9.12266 4.19534 8.862L7.52869 5.52866C7.78934 5.268 8.21066 5.268 8.47134 5.52866Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpWithBg);
export default __webpack_public_path__ + "static/media/up-with-bg.2e0b1195.svg";
export { ForwardRef as ReactComponent };